export default __webpack_public_path__ + "static/media/lykio_logo_transparent.7709cf39.png";